import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { resizeController } from "./resize-controller.js";

const BREAKPOINT = 768;

// Класс на корневом элементе swiper'а, когда пролистано больше SCROLLED_FAR_AFTER слайдов
const SCROLLED_FAR_CLASS = "is-scrolled-far";
const SCROLLED_FAR_AFTER = 2;

// На мобильном превращаем грид в слайдер: оборачиваем карточки
// в .swiper-wrapper и вешаем swiper-классы, на десктопе возвращаем как было.
const createSlider = ($container, $controls) => {
    const $wrapper = document.createElement("div");

    $wrapper.classList.add("swiper-wrapper");
    $wrapper.append(...$container.children);
    $container.append($wrapper);

    $container.classList.add("swiper");
    $container.classList.remove("grid");

    $wrapper.querySelectorAll(".section-mosaic__item").forEach(($item) => {
        $item.classList.add("swiper-slide");
    });

    return new Swiper($container, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.16,
        spaceBetween: 16,
        navigation: {
            prevEl: $controls.querySelector(".slider-controls__arrow--prev"),
            nextEl: $controls.querySelector(".slider-controls__arrow--next")
        },
        pagination: {
            el: $controls.querySelector(".slider-controls__dots"),
            clickable: true
        },
        on: {
            slideChange(swiper) {
                $container.classList.toggle(SCROLLED_FAR_CLASS, swiper.activeIndex > SCROLLED_FAR_AFTER);
            }
        }
    });
};

const destroySlider = ($container, swiper) => {
    swiper.destroy(true, true);

    const $wrapper = $container.querySelector(".swiper-wrapper");

    $container.append(...$wrapper.children);
    $wrapper.remove();

    $container.classList.remove("swiper", SCROLLED_FAR_CLASS);
    $container.classList.add("grid");

    $container.querySelectorAll(".section-mosaic__item").forEach(($item) => {
        $item.classList.remove("swiper-slide");
    });
};

export const mosaicSlider = () => {
    document.querySelectorAll(".section-mosaic__items").forEach(($container) => {
        // Стрелки и точки отрендерены в components/section-mosaic.php
        // (components/slider-controls.php), видимость управляется через CSS
        const $controls = $container.parentElement.querySelector(".slider-controls");

        if (!$controls) {
            return;
        }

        let swiper = null;

        resizeController({
            [BREAKPOINT]: {
                onMatch() {
                    swiper = createSlider($container, $controls);
                },
                onUnmatch() {
                    if (!swiper) {
                        return;
                    }

                    destroySlider($container, swiper);
                    swiper = null;
                }
            }
        });
    });
};
